import React from 'react'
import { useNavigate } from 'react-router-dom'
import { Megaphone } from 'lucide-react'

import SharedNotificationBell from '@/components/shared/NotificationBell'
import { emailNotificationService } from '@/services/emailNotificationService'

// Campaign notifications for admin/hr in Marketing Email (separate from task notifications)
const NotificationBell = () => {
  const navigate = useNavigate()

  return (
    <SharedNotificationBell
      queryKey="email-notifications"
      title="Campaign notifications"
      label="Campaign notifications"
      icon={Megaphone}
      fetchUnreadCount={async () => (await emailNotificationService.getUnreadCount())?.data?.count || 0}
      fetchList={async () => (await emailNotificationService.getNotifications({ limit: 20 }))?.data?.notifications || []}
      isUnread={(n) => !n.is_read}
      onMarkAllRead={emailNotificationService.markAllAsRead}
      onSelect={async (n) => {
        if (!n.is_read) await emailNotificationService.markAsRead(n.id)
        if (n.entity_type === 'campaign' && n.entity_id) navigate(`/marketing-email/campaigns/${n.entity_id}`)
      }}
    />
  )
}

export default NotificationBell
